enum BaseUrl {
  LOCALHOST = 'localhost:8080',
  DEVELOPMENT = 'tc-dev.tradesolution.no',
  QA = 'tc-qa.tradesolution.no',
  PRODUCTION = 'tc.tradesolution.no',
}
enum Environment {
  LOCALHOST = 'Localhost',
  DEVELOPMENT = 'Development',
  QA = 'QA',
  PRODUCTION = 'Production',
}

const isUrlProduction = (): boolean => window.location.host === BaseUrl.PRODUCTION;
const isUrlQA = (): boolean => window.location.host === BaseUrl.QA;
const isUrlDevelopment = (): boolean => window.location.host === BaseUrl.DEVELOPMENT;
const isUrlLocal = (): boolean => window.location.host === BaseUrl.LOCALHOST;

const getEnvironment = (): Environment => {
	if (isUrlProduction()) {
		return Environment.PRODUCTION;
	}
	if (isUrlQA()) {
		return Environment.QA;
	}
	if (isUrlDevelopment()) {
		return Environment.DEVELOPMENT;
	}
	return Environment.LOCALHOST;
};

export {
	getEnvironment,
	Environment,
};